@if (params.value) {
  <span class="tag-element">
    {{params.value}}
  </span>
}
